import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const useSolicitudIdParam = (redirectOnFail = true) => {
    const navigate = useNavigate();
    const { solicitudId } = useParams<{ solicitudId?: string }>();
    const resolvedValue = Number(solicitudId);

    useEffect(() => {
        if (redirectOnFail && !resolvedValue) navigate("/");
    }, [redirectOnFail, resolvedValue, navigate]);

    return resolvedValue;
}

export default useSolicitudIdParam
